var _circle, _rect, _rect2, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_46_2",
    "data-name": "Component 46 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 311.585,
    height: 375,
    viewBox: "0 0 311.585 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 3.899,
    cy: 3.899,
    r: 3.899,
    fill: "#69efad"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 6.238,
    height: 6.238,
    transform: "translate(126.025 370.589) rotate(-45)",
    fill: "#69efad"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 6.238,
    height: 6.238,
    transform: "translate(278.392 45) rotate(-45)",
    fill: "#9460f5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 2.599,
    cy: 2.599,
    r: 2.599,
    transform: "translate(102.604 69.245)",
    fill: "#9460f5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 2.599,
    cy: 2.599,
    r: 2.599,
    transform: "translate(25.604 203.801)",
    fill: "#69efad"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.599,
    cy: 2.599,
    r: 2.599,
    transform: "translate(306.386 203.801)",
    fill: "#9460f5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBackground);
export default __webpack_public_path__ + "static/media/sidebarBackground.43749854b23a07e92a239a4603c65ff6.svg";
export { ForwardRef as ReactComponent };